<template>
  <ImageViewer v-if="isLoad" :isLoad="isLoad" />
  <MainLayout v-if="!isLoad">
    <Banner :data="data" />
    <AboutService :data="data" />
    <ServiceOverview :data="data" />
    <WhyYouNeed :data="data" />
    <GetInTouch :data="data" />
    <Gallery />
    <RequestBookService />
  </MainLayout>
</template>

<script setup>
import ImageViewer from "../Global/ImageViewer.vue";
import Banner from "./Banner.vue";
import AboutService from "./AboutService.vue";
import ServiceOverview from "./ServiceOverview.vue";
import GetInTouch from "./GetInTouch.vue";
import RequestBookService from "../Global/RequestBookService.vue";
import Gallery from "./Gallery.vue";
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { SERVICES } from "../../constants/constants";
import WhyYouNeed from "./WhyYouNeed.vue";
const route = useRoute();
const data = ref({});
const slug = ref(route.params.name);
const isLoad = ref(true);
onMounted(() => {
  if (slug.value !== null) {
    data.value = SERVICES.find(obj => obj.slug === slug.value);
  };
  isLoad.value = false;
  try {
    const title = document.querySelector("head title");
    // title.innerHTML = data.value?.title;
  }
  catch (e) { };
});
onMounted(() => {
  isLoad.value = true;
  if (slug.value !== null) {
    data.value = SERVICES.find(obj => obj.slug === slug.value);
  };
  try {
    const title = document.querySelector("head title");
    // title.innerHTML = data.value?.title;
  }
  catch (e) { };
  isLoad.value = false;
});
watch(
  () => route.params.name,
  (value) => {
    if (route.name === "service-detail") slug.value = value;
  },
);
watch(() => slug.value,
  () => {
    data.value = SERVICES.find(obj => obj.slug === slug.value);
  });
</script>